import http from "@/services/http";

export const deliveryRoute = () => {
  // Paradas (entregas e coletas) do período; datas no formato YYYY-MM-DD
  async function list(start, end) {
    const {data} = await http.get('/deliveryRoute/list', { params: { start, end } });
    return data;
  }

  return {list};
}
